const {airtableTagToDbTag} = require('./index');

const CompanyExperience = {
  WORKED: 'worked',
  INTERVIEWED: 'interviewed',
};

const toDbTags = (companies) => (companies || []).map(airtableTagToDbTag);

/**
 * How a coach's experience relates to a company tag. Worked is direct
 * experience (a past employer). Interviewed covers companies the coach only
 * interviewed at, plus the legacy "Companies" field.
 *
 * @param {object} coach Coach fields as named in Airtable.
 * @param {string} company A company tag id (e.g. 'google').
 * @returns {string|null} A CompanyExperience value, or null if unrelated.
 */
const getCompanyExperience = (coach, company) => {
  if (!coach || !company) return null;
  if (toDbTags(coach['Companies Worked']).includes(company)) {
    return CompanyExperience.WORKED;
  }
  const related = [
    ...toDbTags(coach['Companies Interviewed']),
    ...toDbTags(coach.Companies),
  ];
  return related.includes(company) ? CompanyExperience.INTERVIEWED : null;
};

module.exports = {
  CompanyExperience,
  getCompanyExperience,
};
